export default "__VITE_ASSET__BRnaxhmK__"